import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { EidosUtilityService } from '@common/services/eidos-utility.service';
import { EidosIconType, EidosLogSeverity } from '@common/models/core-constant.model';
import { EidosLogService } from '@common/services/eidos-log.service';
import { EidosResetCredentialsStatus } from '@common/models/eidos-dialog.interface';
import { IEidosIcon } from '@common/config/environment.interface';
import { ModalRef } from '@app/core/services/core-modal.service';

@Component({
    selector: 'eidos-reset-credentials-dialog',
    styleUrls: [
        'eidos-reset-credentials-dialog.component.scss'
    ],
    templateUrl: 'eidos-reset-credentials-dialog.component.html',
    standalone: false
})
export class EidosResetCredentialsDialogComponent implements OnInit, OnDestroy {
  @Input() modalRef!: ModalRef;

  EidosResetCredentialsStatus = EidosResetCredentialsStatus;
  /**
   * Form
   *
   * @memberof EidosResetCredentialsDialogComponent
   */
  public form = new UntypedFormGroup({
    username: new UntypedFormControl('', Validators.required)
  });
  /**
   * Current status
   *
   * @type {EidosResetCredentialsStatus}
   * @memberof EidosResetCredentialsDialogComponent
   */
  public status: EidosResetCredentialsStatus = EidosResetCredentialsStatus.Entered;
  /**
 * Ok icon configuration
 *
 * @type {IEidosIcon}
 * @memberof EidosResetCredentialsDialogComponent
 */
  public okIcon: IEidosIcon = {
    iconType: EidosIconType.Awesome,
    iconCode: "fa-check",
    iconSize: 2,
  };
  /**
   * Error icon configuration
   *
   * @type {IEidosIcon}
   * @memberof EidosResetCredentialsDialogComponent
   */
  public clearIcon: IEidosIcon = {
    iconType: EidosIconType.Awesome,
    iconCode: "fa-xmark",
    iconSize: 2,
  };

  constructor(
    private eidosUtilityService: EidosUtilityService
    , private eidosLogService: EidosLogService
  ) {
  }

  ngOnInit() {
  }

  /**
   * Cancel button handler
   *
   * @memberof EidosResetCredentialsDialogComponent
   */
  onCancelClick(): void {
    this.modalRef.close();
  }

  /**
   * Submit handler
   *
   * @return {*}  {void}
   * @memberof EidosResetCredentialsDialogComponent
   */
  onSubmit(): void {
    let username = this.form.get('username');

    if (!!username?.value) {
      this.eidosLogService.logDebug(EidosLogSeverity.Log, "Eidos: requested password reset for user ", username);
      this.status = EidosResetCredentialsStatus.Requested;
      this.eidosUtilityService.resetCredentials(username.value).subscribe(result => {
        if (!!result) {
          this.status = EidosResetCredentialsStatus.Ok;
        } else {
          // Log failure
          this.eidosLogService.logDebug(EidosLogSeverity.Log, 'Eidos: password reset fail for API error (Maybe too many request from user?)');
          this.status = EidosResetCredentialsStatus.Error;
        }
      });
    }
  }
  /**
   * Retry to reset credentials after fail
   *
   * @memberof EidosResetCredentialsDialogComponent
   */
  public onRetry(): void {
    let username = this.form.get('username');
    username?.reset();
    this.status = EidosResetCredentialsStatus.Entered;
  }

  ngOnDestroy() {
  }
}
